import firebase from "firebase/app";
import "firebase/firestore";
const config = {
    // apiKey: "AIzaSyC_-RBeqL2SQUEBmXtaCnXG8tHMNH8taDU",
    // authDomain: "motor-c1ab1.firebaseapp.com",
    // projectId: "motor-c1ab1",
    // storageBucket: "motor-c1ab1.appspot.com",
    // messagingSenderId: "707210558082",
    // appId: "1:707210558082:web:a42c74e1945f6a40f1d29b"

    apiKey: "AIzaSyC4Rh3f90AcFLtetKcCCBfzhU0oFH_A_Ws",
    authDomain: "zhongji.firebaseapp.com",
    projectId: "zhongji",
    storageBucket: "zhongji.appspot.com",
    messagingSenderId: "519981786499",
    appId: "1:519981786499:web:307d96671ceb9961d682b6"

}
// firebase.initializeApp(config);

export const db = !firebase.apps.length
    ? firebase.initializeApp(config).firestore()
    : firebase.app().firestore();

export default function Firebasse(){
    return(
        <div></div>
    )
}
